import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { SignalDetail } from "@/services/DTOs/SignalDetail";
import { Signals } from "@/services/DTOs/Signals";
import { trackAPICall } from "@/services/SnowplowService";
import { OpportunitiesApiService } from "./OpportunitiesApiService";

class Service {

  public getSignals(signaledUsername: string): Observable<Signals> {
    const url = `/api/genome/people/${signaledUsername}/signals`;

    return OpportunitiesApiService.get(url).pipe(map((response) => response.data));
  }

  @trackAPICall("POST", "Signals", "personSignal")
  public signalPerson(targetUsername: string): Observable<string | undefined> {
    const url = `/api/genome/people/${targetUsername}/signals?implicit=false`;

    return OpportunitiesApiService.post(url, { }).pipe(
      map((response) => response.data.id));
  }

  @trackAPICall("DELETE", "Signals", "personUnsignal")
  public unsignalPerson(targetUsername: string): Observable<string | undefined> {
    const url = `/api/genome/people/${targetUsername}/signals`;

    return OpportunitiesApiService.delete(url, { }).pipe(map(() => undefined));
  }

  @trackAPICall("POST", "Signals", "organizationSignal")
  public signalOrganization(targetId: string): Observable<string | undefined> {
    const url = `/api/genome/organizations/${targetId}/signals?implicit=false`;

    return OpportunitiesApiService.post(url, { }).pipe(
      map((response) => response.data.id));
  }

  @trackAPICall("DELETE", "Signals", "organizationUnsignal")
  public unsignalOrganization(targetId: string): Observable<string | undefined> {
    const url = `/api/genome/organizations/${targetId}/signals`;

    return OpportunitiesApiService.delete(url, { }).pipe(map(() => undefined));
  }

  public updateSignalNotificationsType(entityType: string, entityId: string, newtype: string): Observable<string> {
    const url = `/api/genome/${entityType}/${entityId}/signals/notifications/${newtype}`;

    return OpportunitiesApiService.post(url, { }).pipe(map((response) => response.data));
  }

}

export const SignalsService = new Service();
